import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import AllCateTable from "../../components/Categories/All-Category"

const AllCategory = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>All Categories | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <AllCateTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AllCategory
